import { defineMessages } from 'react-intl';

export const DOMAIN_NAME = 'familyPlanAcceptInvite' as const;

export const Actions = Object.freeze({
  FAMILY_CHILD_CONTINUE_CLICKED: 'FAMILY_CHILD_CONTINUE_CLICKED',
  INITIATE_FAMILY_PLAN_INVITEE_FLOW: 'INITIATE_FAMILY_PLAN_INVITEE_FLOW',
  SET_FAMILY_PLAN_INVITE_CODE: 'SET_FAMILY_PLAN_INVITE_CODE',
} as const);

export const AnalyticsConstants = Object.freeze({
  CONTINUE: 'continue',
  FAMILY_PLAN_CHILD_SUCCESS: 'family_plan_child_success',
} as const);

export const ReducerKeys = Object.freeze({
  FAMILY_PLAN_INVITE_TOKEN: 'familyPlanInviteToken',
  IS_VALID_FAMILY_PLAN_INVITE_TOKEN: 'isValidFamilyPlanInviteToken',
} as const);

export const Messages = defineMessages({
  welcomeToPremiumFamilyHeader: {
    id: 'welcomeToPremiumFamilyHeader',
    defaultMessage: 'Welcome to Pandora Premium Family!',
  },
  welcomeToPremiumFamilyBody: {
    id: 'welcomeToPremiumFamilyBody',
    defaultMessage:
      'You’ve been successfully added to the Pandora Premium Family plan managed by {parentEmail}',
  },
  invalidPremiumFamilyInviteBody: {
    id: 'invalidPremiumFamilyInviteBody',
    defaultMessage:
      'Sorry, this Pandora Premium Family invite is not valid. To join the Pandora Premium Family plan ask the person who manages the family to resend the invite.',
  },
  willBeWaitingWhenYouJoinFamily: {
    id: 'willBeWaitingWhenYouJoinFamily',
    defaultMessage:
      "Albums, songs and playlists you've enjoyed in Pandora Premium will be waiting for you when you join the Family Plan.",
  },
  unableToJoinFamilyPlan: {
    id: 'unableToJoinFamilyPlan',
    defaultMessage: 'Unable to join Pandora Premium Family.',
  },
  accountAlreadySubscribed: {
    id: 'accountAlreadySubscribed',
    defaultMessage:
      "The account that you're currently logged in with, {listenerEmail}, is already subscribed to {planName} via {vendor}.",
  },
  toJoinThePremiumFamilyPlan: {
    id: 'toJoinThePremiumFamilyPlan',
    defaultMessage: 'To join the Pandora Premium Family plan, you can either:',
  },
  loginWithADifferentAccount: {
    id: 'loginWithADifferentAccount',
    defaultMessage: 'Log in with a different account',
  },
  cancelYourExistingSubscription: {
    id: 'cancelYourExistingSubscription',
    defaultMessage: 'Cancel your existing subscription through {vendor}.',
  },
  learnMoreAboutCancelling: {
    id: 'learnMoreAboutCancelling',
    defaultMessage: 'Learn more about cancelling your subscription.',
  },
  waitForSubscriptionExpire: {
    id: 'waitForSubscriptionExpire',
    defaultMessage: 'Wait for your subscription to expire.',
  },
  reacceptYourInvite: {
    id: 'reacceptYourInvite',
    defaultMessage: 'Re-accept your invite.',
  },
  learnMoreAboutJoiningFamily: {
    id: 'learnMoreAboutJoiningFamily',
    defaultMessage: 'Learn more about joining a Pandora Premium Family Plan.',
  },
});
